
    <div class="row">
        <div class="col-sm-7">
            <filter [tabHeading]="'Reports'"></filter>
        </div>

        <report-generator-filter></report-generator-filter>
        <div *ngIf="reportGeneratorService.canEdit()" class="col-sm-3">
            <button type="button"
                    class="btn btn-w-m btn-primary pull-right"
                    (click)="reportGeneratorService.turnComponent('isReportModalShow')">
                <i class="fa fa-plus-circle"></i> New Report
            </button>
        </div>

    </div>
    <tabs-wrapper>
        <tab-item title="Templates"
                  [tabId]="'allTemplates'"
                  [active]="reportGeneratorService.tabId == 'allTemplates'"
                  [ngClass]="{'sk-loading': reportGeneratorService.spinnerShow}">
            <div *ngIf="reportGeneratorService.tabId == 'allTemplates'"
                 class="table-responsive"
                 [class.overflow-hidden]="reportGeneratorService.emptyRowService.emptyRow.length > 0">
                <table class="table table-striped table-hover footable">
                    <thead>
                        <tr [ngClass]="{'noSort': reportGeneratorService.data.allTemplates.data.length < 2}">
                            <th (click)="orderBy('name', $event)">
                                Report Name <span class="footable-sort-indicator"></span>
                            </th>
                            <th (click)="orderBy('description', $event)">
                                Description <span class="footable-sort-indicator"></span>
                            </th>
                            <th (click)="orderBy('isPredefined', $event)">
                                Type <span class="footable-sort-indicator"></span>
                            </th>
                            <th class="footable-sorted-desc" (click)="orderBy('createdAt', $event)">
                                Created On <span class="footable-sort-indicator"></span>
                            </th>
                            <th (click)="orderBy('createdBy', $event)">
                                Created By <span class="footable-sort-indicator"></span>
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template ngFor let-item [ngForOf]="reportGeneratorService.data.allTemplates.data" let-index="index">
                            <tr [ngClass]="{'footable-odd': (index % 2 === 0)}">
                                <td [title]="item.name">{{item.name}}</td>
                                <td class="report-generator-hint-td">
                                    <div class="clickable-text mtv-primary-color" (click)="showHint($event)">
                                        {{item.description}}
                                    </div>
                                    <div class="report-generator-hint {{index > 7 ? 'up' : 'down'}}">
                                        <pre>{{item.description}}</pre>
                                    </div>
                                </td>
                                <td>
                                    <span *ngIf="item.isPredefined">Pre Set</span>
                                    <span *ngIf="!item.isPredefined">Custom</span>
                                </td>
                                <td>{{item.createdAt | mccDate:true:true}}</td>
                                <td>{{item.createdByName}}</td>
                                <td class="td-action-btn">
                                    <div *ngIf="item.isCanEdit" class="input-group-btn btn-in-table input-group">
                                        <button (click)="reportGeneratorService.checkIfTemplateHasRuntimeConditions(item)"
                                                class="btn btn-white btn-xs sign-out-return-buttons">
                                            Run Report
                                        </button>
                                        <button data-toggle="dropdown" class="btn btn-white dropdown-toggle btn-xs"
                                                aria-expanded="false">
                                            <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu pull-right">
                                            <li *ngIf="item.isCanEdit"
                                                (click)="reportGeneratorService.openTemplate(item, true)">
                                                <a>Create a Copy</a>
                                            </li>
                                            <li *ngIf="item.isCanEdit && !item.isPredefined"
                                                (click)="reportGeneratorService.openTemplate(item, false)">
                                                <a>Edit</a>
                                            </li>
                                            <li *ngIf="!item.isCanEdit || item.isPredefined"
                                                (click)="reportGeneratorService.viewTemplate(item)">
                                                <a>View</a>
                                            </li>
                                            <li *ngIf="item.isCanDelete && !item.isPredefined"
                                                (click)="reportGeneratorService.deleteTemplate(item)">
                                                <a>Delete</a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <tr *ngFor="let item of reportGeneratorService.emptyRowService.emptyRow" style="cursor: default;">
                            <td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="reportGeneratorService.data.allTemplates.total == 0 && !reportGeneratorService.showServiceUnavailable"
                    class="text-center">
                    <h2>Result Not Found</h2>
                    <a class="text-center">
                        <broad-match-toggle></broad-match-toggle>
                    </a>
                </div>
                <h2 *ngIf="reportGeneratorService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
            </div>
        </tab-item>
        <tab-item title="Reports"
                  [tabId]="'allReports'"
                  [active]="reportGeneratorService.tabId == 'allReports'"
                  [ngClass]="{'sk-loading': reportGeneratorService.spinnerShow}">
            <div *ngIf="reportGeneratorService.tabId == 'allReports'"
                 class="table-responsive"
                 [class.overflow-hidden]="reportGeneratorService.emptyRowService.emptyRow.length > 0">
                <table class="table table-striped table-hover key-log-list-table footable"
                       *ngIf="reportGeneratorService.data.allReports.data.length">
                    <thead>
                        <tr [ngClass]="{'noSort': reportGeneratorService.data.allReports.data.length < 2}">
                            <th (click)="orderBy('reportTemplate.name', $event)">
                                Report Name <span class="footable-sort-indicator"></span>
                            </th>
                            <th (click)="orderBy('status', $event)">
                                Status <span class="footable-sort-indicator"></span>
                            </th>
                            <th class="footable-sorted-desc" (click)="orderBy('createdAt', $event)">
                                Created On <span class="footable-sort-indicator"></span>
                            </th>
                            <th (click)="orderBy('createdBy', $event)">
                                Created By <span class="footable-sort-indicator"></span>
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template ngFor let-item [ngForOf]="reportGeneratorService.data.allReports.data" let-index="index">
                            <tr [ngClass]="{'footable-odd': (index % 2 === 0)}">
                                <td [title]="item ? item.name: ''">
                                    {{item ? item.name: ''}}
                                </td>
                                <td>
                                    <span *ngIf="item.status === 'done'" class="same-label-width label label-done">
                                        Done
                                    </span>
                                    <span *ngIf="item.status === 'in_progress' || item.status === 'wait'"
                                          class="same-label-width label label-in-progress">
                                        In Progress
                                    </span>
                                    <span *ngIf="item.status === 'fail'" class="same-label-width label label-failed">
                                        Failed
                                    </span>
                                </td>
                                <td>{{item.createdAt | mccDate:true:true}}</td>
                                <td>{{item.createdByName}}</td>
                                <td class="td-action-btn">
                                    <div *ngIf="item.status == 'done'" class="input-group-btn btn-in-table input-group">
                                        <button class="btn btn-white btn-xs sign-out-return-buttons"
                                                (click)="openReport(item, 'html')">
                                            Open Report as HTML
                                        </button>
                                        <button data-toggle="dropdown" class="btn btn-white dropdown-toggle btn-xs"
                                                aria-expanded="false">
                                            <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu pull-right">
                                            <li (click)="openEditNameModal(item)"><a>Edit Name</a></li>
                                            <li (click)="openReport(item, 'pdf')"><a>Open Report as PDF</a></li>
                                            <li (click)="openReport(item, 'xlsx')" ><a>Open Report as XLSX</a></li>
                                            <li (click)="openCustomViewReport(item)" ><a>Custom View (PDF)</a></li>
                                            <li (click)="reportGeneratorService.deleteReport(item)"><a>Delete</a></li>
                                        </ul>
                                    </div>
                                    <div *ngIf="item.status == 'fail'" class="input-group-btn btn-in-table input-group">
                                        <button class="btn btn-white btn-xs sign-out-return-buttons"
                                                (click)="reportGeneratorService.deleteReport(item)">
                                            Delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <tr *ngFor="let item of reportGeneratorService.emptyRowService.emptyRow" style="cursor: default;">
                            <td>&nbsp;</td><td></td><td></td><td></td><td></td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="reportGeneratorService.data.allReports.total == 0 && !reportGeneratorService.showServiceUnavailable"
                    class="text-center">
                    <h2>Result Not Found</h2>
                    <a class="text-center">
                        <broad-match-toggle></broad-match-toggle>
                    </a>
                </div>
                <h2 *ngIf="reportGeneratorService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
            </div>
        </tab-item>
        <pagination *ngIf="reportGeneratorService.data[reportGeneratorService.tabId].total && urlService.queryParams['page']"
                    [total]="reportGeneratorService.data[reportGeneratorService.tabId].total">
        </pagination>
        <spinner [spinnerShow]="reportGeneratorService.spinnerShow"></spinner>
    </tabs-wrapper>



// WEBPACK FOOTER //
// /app/src/app/views/report-generator/report-generator-list/report-generator-list.component.html